// -----------------------------------------------------------------------
// <copyright file='IdentityChangedAction.ts' company='Microsoft'>
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum IdentityChangedAction {
  SignIn = 'SignIn',
  SignOut = 'SignOut',
  Update = 'Update',
}
